import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastService } from '../../../services/toast.service';
import { DescricaoPadraoService } from '../../../services/descricao-padrao.service';
import { SeveridadeToast } from '../../../models/enums/severidade-toast.enum';
import { JwtHelper } from '../../../helpers/jwtDecode.helper';
import { SpinnerService } from '../../../services/spinner.service';
import { Icones } from '../../../shared/variaveisDeRotas';

@Component({
  selector: 'app-descricao-padrao-editar',
  templateUrl: './descricao-padrao-editar.component.html',
  styleUrls: ['./descricao-padrao-editar.component.scss']
})
export class DescricaoPadraoEditarComponent implements OnInit {
  @Output() tituloChange = new EventEmitter<string>();
  @Output() iconeChange = new EventEmitter<string>();

  descricaoPadraoForm: FormGroup = new FormGroup({
    id: new FormControl(0),
    descricao: new FormControl('', Validators.required),
    detalhes: new FormControl(''),
    usuarioId: new FormControl(''),
  });
  caminhoImagem: string = '../../../assets/img/undraw_annotation_re_h774.svg';
  private userId: string;
  private descricaoId: number;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private toastService: ToastService,
    private descricaoPadraoService: DescricaoPadraoService,
    private jwtHelper: JwtHelper,
    private spinnerService: SpinnerService,
  ) { }

  ngOnInit(): void {
    this.tituloChange.emit('Editar Descrição Padrão');
    this.iconeChange.emit(Icones.pranchetaAmarelo);

    this.userId = this.jwtHelper.getUserIdFromToken();
    this.descricaoPadraoForm.get('usuarioId')?.setValue(this.userId);

    this.route.params.subscribe(params => {
      this.descricaoId = +params['id'];
      if (this.descricaoId) {
        this.carregarDescricaoPadrao();
      }
    });
  }

  carregarDescricaoPadrao(): void {
    this.spinnerService.show('Carregando descrição padrão...');
    this.descricaoPadraoService.getDescricaoPadraoById(this.descricaoId).subscribe({
      next: (descricao) => {
        this.descricaoPadraoForm.patchValue({
          id: descricao.id,
          descricao: descricao.descricao,
          detalhes: descricao.detalhes,
          usuarioId: descricao.usuarioId
        });
        this.spinnerService.hide();
      },
      error: (e) => {
        this.retornarMensagemErro(e);
        this.spinnerService.hide();
        this.router.navigate(['/descricao-padrao']);
      }
    });
  }

  onSubmit(): void {
    if (this.descricaoPadraoForm.valid) {
      this.spinnerService.show('Salvando alterações...');
      this.descricaoPadraoService.updateDescricaoPadrao(this.descricaoPadraoForm.value)
        .subscribe({
          next: () => {
            this.retornarMensagemSucesso('Descrição atualizada com sucesso.');
            this.router.navigate(['/descricao-padrao']);
            this.spinnerService.hide();
          },
          error: (e) => {
            this.retornarMensagemErro(e);
            this.spinnerService.hide();
          }
        });
    }
  }

  onCancel(): void {
    this.router.navigate(['/descricao-padrao']);
  }

  retornarMensagemSucesso(mensagem: string) {
    this.toastService.setMensagemToast(mensagem, SeveridadeToast.Success);
  }

  retornarMensagemErro(e: any) {
    let errorMessage = 'Erro desconhecido';

    if (typeof e.error === 'string') {
      errorMessage = e.error;
    } else if (Array.isArray(e.error)) {
      errorMessage = e.error.join(', ');
    } else if (e.error?.message) {
      errorMessage = e.error.message;
    } else {
      console.error('Erro ao processar erro:', e);
    }

    this.toastService.setMensagemToast(
      `Erro ao atualizar Descrição Padrão: ${errorMessage}`,
      SeveridadeToast.Error
    );
  }
}
